import { Input } from '@/components/ui'
import { formatPhoneNumber, formatSiret } from '@/utils/formatters'
import EmailLink from '@/components/EmailLink'
import Address from "@/components/Address"

import { CivilitesMapping } from '../contactsSlice'
import { useContactContext } from '../ContactShow'
import { Spinner } from '../../../components/ui'
import { InformationCircleIcon, UserCircleIcon } from '@heroicons/react/24/outline'

export default () => {
  const { contact, loading } = useContactContext()
  return (
    <>
      <div>
        <Input.Display label="Raison sociale" value={contact.nom} valueClassName="uppercase" />
        <Input.Display label="Forme juridique" value={contact.civilite} />
        <Input.Display label="SIRET" value={formatSiret(contact.siret)} />
      </div>
      <div>
        <Input.Display label="Adresse" value={contact.ville} forceEmptyPlaceholder={true} className="flex mb-2" valueClassName="uppercase">
          <Address data={contact} />
        </Input.Display>
        { contact.civilite !== "SCI" && (
          <>
            <Input.Display label="Téléphone" value={formatPhoneNumber(contact.telephone)} />
            <Input.Display label="Email" value={contact.email} forceEmptyPlaceholder={true} >
              <EmailLink email={contact.email} />
            </Input.Display>
          </>
        )}
      </div>
      { contact.contacts?.length == 0 && (
        <Input.Display label="Contact">
          {loading && <Spinner color="primary" />}
        </Input.Display>
      )}
      { !!contact.contacts && contact.contacts.length > 0 && (<div>
          <h3 className="flex items-center gap-2">Contacts :</h3>
          {contact.contacts.map(
            (contactPhysique, index) => (
              <div key={index} className="flex items-center">                
                <span className="upperCase">{`${CivilitesMapping[contactPhysique.civilite] || ''} ${contactPhysique.nom_complet}`}</span>
                <div className='dropdown dropdown-hover'>
                  <div tabIndex={0} role="button" className="btn btn-circle btn-ghost btn-xs m-1"><InformationCircleIcon className="size-5" /></div>
                  <div tabIndex={0} className="card dropdown-content w-90 bg-base-100 rounded-box z-1 p-2 shadow-sm">
                    <div tabIndex={0} className="card-body">
                      <Input.Display label="Téléphone" value={formatPhoneNumber(contactPhysique.telephone)}
                        className="flex flex-wrap items-center"
                      />

                      <Input.Display label="Email" value={contactPhysique.email} forceEmptyPlaceholder={true} 
                        className="flex flex-wrap items-center"
                      >
                        <EmailLink email={contactPhysique.email} />
                      </Input.Display>

                      <Input.Display label="Adresse" value={contactPhysique.ville} forceEmptyPlaceholder={true} className="flex" valueClassName="uppercase">
                        <Address data={contactPhysique} />
                      </Input.Display>

                    </div>
                    <div className="justify-end card-actions">
                      <a href={`/contacts/${contactPhysique.id}`} className="btn">Voir la fiche</a>
                    </div>
                  </div>
                </div>
              </div>
            )
          )}
        </div>)
      }
    </>
  )
}